import React from 'react'

const AlertDialog = ({ role = "alert", children }) => {
  return (
    <div role={role} aria-hidden="false" className="hidden">{children}</div>
  )
}

export default AlertDialog